import React, { useEffect, useState, useRef } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider, Select, InputLabel, Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import Iconify from '../../common/Iconify/Iconify';


const ScatterSaveToDatabase = ({ open, handleClose, savedDots }) => {

  /*const definition*/
  const [loading, setLoading] = useState(false);
  const [namelocal, setNameLocal] = useState("");
  const [emaillocal, setEmailLocal] = useState("");
  const [citylocal, setCityLocal] = useState("");
  const [countrylocal, setCountryLocal] = useState("");
  const [categorylocal, setCategoryLocal] = useState("");
  const [idclientlocal, setID_ClientLocal] = useState("");
  const [biolocal,setBioLocal] = useState("");
  const [password,setPassword] = useState("");
  const [newpassword,setNewPassword] = useState("");
  



  /*clean up variables*/

  const cleanFormData = () => {
      setNameLocal("");
      setEmailLocal("");
      setCityLocal("");
      setCountryLocal("");
      setBioLocal("");
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });


  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose();
        }
      }}
      ModalProps={{
        disableEnforceFocus: true,
      }}
    >
      <DialogTitle>Save your scatter plot inputs</DialogTitle>
      <Divider sx={{ paddingY : "1rem", marginBottom: "1rem", }}></Divider>
      <DialogTitle fontSize={10}>Confirm the following values and data. You can modify these values in your profile page</DialogTitle>

      <DialogContent>
  {savedDots.map((dot, index) => (
    <div key={index} style={{ display: 'flex', flexDirection: 'row', marginBottom: '1rem' }}>
      <div style={{ marginRight: '1rem' }}>
        <TextField
          label={`Strategy Name - Dot ${index + 1}`}
          value={dot.title}
          fullWidth
          InputProps={{
            readOnly: true,
          }}
          margin="normal"
        />
      </div>
      <div style={{ marginRight: '1rem' }}>
        <TextField
          label={`X Coordinate - Dot ${index + 1}`}
          value={dot.x}
          fullWidth
          InputProps={{
            readOnly: true,
          }}
          margin="normal"
        />
      </div>
      <div>
        <TextField
          label={`Y Coordinate - Dot ${index + 1}`}
          value={dot.y}
          fullWidth
          InputProps={{
            readOnly: true,
          }}
          margin="normal"
        />
      </div>
    </div>
  ))}
</DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleClose}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScatterSaveToDatabase;